import styled from '@emotion/styled';
import React from 'react';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${props => props.marginBottom || '10px'};
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #f0f0f0;
`;

const Label = styled.div`
  flex: 1;
  padding: 2px 0;
  font-size: 11px;
  font-weight: bold;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 0.3px;
`;

const Value = styled.div`
  flex: 2;
  padding: 2px 0;
  font-size: 12px;
  color: #333;
  display: flex;
  align-items: center;
`;

const ReviewInfoTable = ({ rows, marginBottom }) => {
  const visibleRows = (rows || []).filter(item => item && item.value !== undefined && item.value !== null);

  return (
    <Wrapper
      marginBottom={marginBottom}
    >
      {
        visibleRows.map((item, index) => (
          <Row key={`${item.label}-${index}`}>
            <Label>{item.label}</Label>
            <Value>{item.value}</Value>
          </Row>
        ))
      }
    </Wrapper>
  );
};

export default ReviewInfoTable;
